import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { applyCenterWatermarkAndUpload, applyWatermarkAndUpload, uploadMediaToS3Bucket, deleteMediaFromS3Bucket } from "services/awsHelper";
import ImageUploading from "react-images-uploading";
import { useAppSelector } from "hooks/store/hooks";
import React from "react";
import { selectColorThemeMode } from "stores/uiSlice";
import DefaultAvatar from "components/Icons/Common/addImage.svg";
import { Box, Center, Image, Spinner, Text } from "@chakra-ui/react";
import DeleteIcon from "components/Icons/UserPageIcons/DeleteIcon.svg";

const SingleImageComponent = ({ imgKey, height, width, title = "cover Image", waterMarkPermissions = 'Default', updateImageFunction }, ref) => {

    const colorThemeMode = useAppSelector(selectColorThemeMode);
    const [imgURLObj, setImgURLObj] = useState({});

    useEffect(() => {
        if (imgKey) {
            setImgURLObj({
                key: imgKey,
                data_url: process.env.REACT_APP_IMAGE_API_URL + imgKey
            })
        }
    }, [imgKey])

    const handleCoverImageUpload = (images) => {
        if (images.length) {

            let nameArray = images[0].file.name.split(".");
            let key = `${nameArray[0]}_${Date.now()}.webp`;
            setImgURLObj({ key, ...images[0] })
            updateImageFunction(key);
        } else {
            setImgURLObj({})
            updateImageFunction("");
        }
    }

    const triggerUpload = async () => {
        debugger;
        if (imgKey !== imgURLObj.key) {
            deleteMediaFromS3Bucket(imgKey);
        }

        if (imgURLObj.file) {
            switch (waterMarkPermissions) {
                case "CenterOnly":
                    await applyCenterWatermarkAndUpload([imgURLObj])
                    break;
                case "CenterAndBottomOnly":
                    await applyWatermarkAndUpload([imgURLObj])
                    break;

                default:
                    await uploadMediaToS3Bucket([imgURLObj]);
                    break;
            }
        }
    };

    useImperativeHandle(ref, () => ({
        triggerUpload,
    }));

    return (
        <>
            <Box w={width} h={height} position={"relative"}>

                <Text variant={"secondary14"} lineHeight={"20px"} mb={"6px"}>{title} </Text>
                <ImageUploading
                    onChange={handleCoverImageUpload}
                    maxNumber={1}
                    dataURLKey="data_url"
                >
                    {({ onImageUpload, onImageRemove }) => (
                        <>
                            <Box
                                h={"85%"}
                                w={"100%"}
                                borderRadius={"8px"}
                                border={"1px solid #CCCCCC"}
                                overflow={"hidden"}
                                p={1}
                            >
                                <Box onClick={onImageUpload} cursor={"pointer"} height={"100%"} width={"100%"}>
                                    <Image
                                        objectFit={"cover"}
                                        height={"100%"}
                                        width={"100%"}
                                        borderRadius={"8px"}
                                        fallback={
                                            <Center h={"100%"}>
                                                <Spinner />
                                            </Center>
                                        }
                                        src={
                                            imgURLObj.data_url
                                                ? imgURLObj.data_url
                                                : DefaultAvatar
                                        }
                                    />
                                </Box>
                            </Box>
                            {imgURLObj.data_url && (
                                <Box
                                    position={"absolute"}
                                    w={"36px"}
                                    h={"36px"}
                                    top={"15%"}
                                    right={"-5%"}
                                    borderRadius={"full"}
                                    onClick={onImageRemove}
                                    bgColor={`${colorThemeMode}_primary`}
                                    display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    cursor={"pointer"}
                                >
                                    <Image src={DeleteIcon} />
                                </Box>
                            )}
                        </>
                    )}
                </ImageUploading>
            </Box>
        </>
    )

}

export default forwardRef(SingleImageComponent);